"use client";

import { ThreadMessageLike } from "@assistant-ui/react";
import { AppendMessage } from "@assistant-ui/react";
import {
  AssistantRuntimeProvider,
  useExternalStoreRuntime,
} from "@assistant-ui/react";
import { useState, useContext, useEffect } from "react";
import { ChatbotWebSocketContext } from "./chatbotWssProvider";
import { PRODUCTION } from './global';

const convertMessage = (message: ThreadMessageLike) => {
  return message;
};

// Get substring of given length or before new line is met
function getSubstring(string) {
  if (string.length > 30) {
    let substring = string.substring(0, 30)
    if (substring.includes('\n')) {
      substring = substring.substring(0, substring.indexOf("\n"));
    }
    substring += '...'
    return substring;
  } else {
    let substring = string
    if (substring.includes('\n')) {
      substring = substring.substring(0, substring.indexOf("\n"));
    }
    return substring;
  }
}

export function ChatbotRuntimeProvider({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const [messages, setMessages] = useState<readonly ThreadMessageLike[]>([]);
  const chatbot = useContext(ChatbotWebSocketContext)

  useEffect(() => {
    if (chatbot.lastMessage != null) {
      let response = chatbot.lastMessage.text + '\n\n'
      // Add references as links on end of message
      chatbot.lastMessage.context.map(each => {
        response += `\n\n**${each.metadata.interview_id}:** [${getSubstring(each.page_content)}](${PRODUCTION ? "https://apps.ilsp.gr/justredi/" : 'https://chomsky.ilsp.gr:3003/justredi/'}/editor/?asr_result_id=${each.metadata.asr_result_id})`
      })
      const assistantMessage: ThreadMessageLike = {
        role: "assistant",
        // Edit response to fit to chatbot.lastMessage type
        content: [{ type: "text", text: response }],
      };
      setMessages((currentMessages) => [...currentMessages, assistantMessage]);
    }
  }, [chatbot.lastMessage])

  const onNew = async (message: AppendMessage) => {
    if (message.content.length !== 1 || message.content[0]?.type !== "text") {

      throw new Error("Only text content is supported");
    } else {
      // Edit message to be text only
      chatbot.sendMessage(message)
      const userMessage: ThreadMessageLike = {
        role: "user",
        content: [{ type: "text", text: message.content[0].text }],
      };
      setMessages((currentMessages) => [...currentMessages, userMessage]);
    }
  };

  const runtime = useExternalStoreRuntime<ThreadMessageLike>({
    messages,
    setMessages,
    onNew,
    convertMessage,
  });

  return (
    <AssistantRuntimeProvider runtime={runtime}>
      {children}
    </AssistantRuntimeProvider>
  );
}

// import React, { useContext, useEffect } from "react";
// import { AssistantRuntimeProvider, useLocalRuntime } from "@assistant-ui/react";
// import { ChatbotWebSocketContext } from "./chatbotWssProvider";

// export function ChatbotRuntimeProvider({ children }) {
//   const chatbot = useContext(ChatbotWebSocketContext)
//   const { socket, connected, lastMessage, sendMessage, connect, disconnect } = chatbot

//   const MyModelAdapter = {
//     async run({ messages, abortSignal }) {
//       // TODO replace with your own API
//       const result = await fetch("<YOUR_API_ENDPOINT>", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         // forward the messages in the chat to the API
//         body: JSON.stringify({
//           messages,
//         }),
//         // cancel request when user aborts
//         signal: abortSignal,
//       });

//       const data = await result.json();

//       return {
//         content: [
//           {
//             type: "text",
//             text: data.text,
//           },
//         ],
//       };
//     },
//   };
//   const runtime = useLocalRuntime(MyModelAdapter);

//   return (
//     <AssistantRuntimeProvider runtime={runtime}>
//       {children}
//     </AssistantRuntimeProvider>
//   );
// }